<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{$route.meta.title}}
                        <el-button class="title_btn" type="primary" @click="$router.push('/service/notice/create')">등록</el-button>
                    </div>
                    <board-list-component :boardType="`notice`"></board-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import BoardListComponent from "@/components/board/BoardListComponent";
    export default {
        name: 'Notice',
        mixins: [],
        components: {
            BoardListComponent,
        },
        props: {
        },
        data() {
            return{

            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{

        },
        watch: {

        },
    }
</script>
